// import { useState, useEffect, useRef } from "react";
// import "./Outbound.css";
// import Table from "react-bootstrap/Table";
// import Axios from "axios";
// import Button from "react-bootstrap/Button";
// import swal from "sweetalert";
// import alertify from "alertifyjs";
// import "alertifyjs/build/css/alertify.min.css";

// function Outbound() {
//   const [data, setData] = useState([]);
//   const [selectedRows, setSelectedRows] = useState([]);
//   const [barcode, setBarcode] = useState("");
//   const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
//   const [scannedBarcodes, setScannedBarcodes] = useState([]);
//   const barcodeInputRef = useRef(null);
//   const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);
//   const [selectedDistributor, setSelectedDistributor] = useState(null);
//   const [isInputDisabled, setIsInputDisabled] = useState(false);

//   useEffect(() => {
//     Axios.get("http://13.200.156.92:5000/getshipment").then((response) => {
//       setData(response.data);
//     });
//   }, []);

//   const handleCheckboxChange = (orderIndex, itemIndex) => {
//     const updatedSelectedRows = [...selectedRows];
//     const foundIndex = updatedSelectedRows.findIndex(
//       (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
//     );

//     if (foundIndex === -1) {
//       updatedSelectedRows.push({ orderIndex, itemIndex });
//       setSelectedCheckboxCount(selectedCheckboxCount + 1);
//     } else {
//       updatedSelectedRows.splice(foundIndex, 1);
//       setSelectedCheckboxCount(selectedCheckboxCount);
//     }

//     setSelectedRows(updatedSelectedRows);

//     if (selectedCheckboxCount === 1) {
//       window.location.reload();
//     }
//   };
//   const handleBarcodeScanned = (scannedBarcode) => {
//     const selectedRow = selectedRows.find((row) =>
//       scannedBarcode.includes(
//         data[row.orderIndex].updatedQuantity[row.itemIndex].sku
//       )
//     );

//     const isBarcodeAlreadyEntered =
//       enteredBarcodesList.includes(scannedBarcode);

//     if (isBarcodeAlreadyEntered) {
//       alertify.error("Barcode already exists in the list");
//       setBarcode("");
//       return;
//     }

//     if (selectedRow) {
//       const selectedItem =
//         data[selectedRow.orderIndex].updatedQuantity[selectedRow.itemIndex];
//       const skuExists = selectedRows.some((row) =>
//         scannedBarcode.includes(
//           data[row.orderIndex].updatedQuantity[row.itemIndex].sku
//         )
//       );

//       if (enteredBarcodesList.length === selectedItem.approvedquantity) {
//         alertify.alert("Quantity matched", "Stop scanning.").set({
//           onshow: function () {
//             setIsInputDisabled(true);
//           },
//           onclose: function () {
//             setIsInputDisabled(false);
//           },
//         });
//         setBarcode("");
//         return;
//       }

//       if (skuExists) {
//         setScannedBarcodes([
//           ...scannedBarcodes,
//           {
//             enteredBarcode: scannedBarcode,
//           },
//         ]);
//         setBarcode("");
//         setEnteredBarcodesList([...enteredBarcodesList, scannedBarcode]);

//         if (enteredBarcodesList.length === selectedItem.approvedquantity - 1) {
//           alertify.alert("Quantity matched", "Stop scanning.");
//           setBarcode("");
//           return;
//         }

//         alertify.success("Barcode scanned successfully");
//       } else {
//         alertify.error("SKU not found in the scanned barcode");
//         setBarcode("");
//       }
//     } else {
//       alertify.error("SKU not found in the scanned barcode");
//       setBarcode("");
//     }
//   };

//   const handleManualBarcodeAddition = () => {
//     if (barcode.trim() !== "") {
//       const skuExists = selectedRows.some((row) =>
//         barcode.includes(
//           data[row.orderIndex].updatedQuantity[row.itemIndex].sku
//         )
//       );

//       if (skuExists) {
//         handleBarcodeScanned(barcode);
//       } else {
//         alertify.error("SKU not found in the entered barcode");
//         setBarcode("");
//       }
//     } else {
//       alertify.error("Please enter a barcode");
//       setBarcode("");
//     }
//   };

//   useEffect(() => {
//     if (barcodeInputRef.current) {
//       barcodeInputRef.current.focus();
//     }

//     const handleClickOutsideInput = (event) => {
//       if (
//         barcodeInputRef.current &&
//         !barcodeInputRef.current.contains(event.target)
//       ) {
//         barcodeInputRef.current.focus();
//       }
//     };

//     document.addEventListener("click", handleClickOutsideInput);

//     return () => {
//       document.removeEventListener("click", handleClickOutsideInput);
//     };
//   }, []);

//   function handleSubmit() {
//     if (enteredBarcodesList.length === 0) {
//       swal("Error", "Please add a barcode first", "error");
//       return;
//     }

//     const selectedShipmentIDsString = selectedRows
//       .map((row) => data[row.orderIndex].shipmentid)
//       .join(", ");

//     const selectedDistributorNamesString = selectedRows
//       .map((row) => data[row.orderIndex].distributorName)
//       .join(", ");

//     const orderNumbers = selectedRows
//       .map((row) => data[row.orderIndex].orderid)
//       .join(", ");
//     const batchIDs = selectedRows
//       .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].batchid)
//       .join(", ");
//     const titles = selectedRows
//       .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].title)
//       .join(", ");

//     const dataToSend = {
//       orderno: orderNumbers,
//       barcodeData: enteredBarcodesList,
//       count: enteredBarcodesList.length,
//       BatchID: batchIDs,
//       Title: titles,
//     };

//     console.log(dataToSend);
//     const postResult = Axios.post(
//       "http://13.200.156.92:5000/scanInbound",
//       dataToSend
//     );
//     console.log(postResult.data);

//     const shipmentDataToPost = {
//       totalCount: enteredBarcodesList.length,
//       totalBoxes: 1,
//       totalWeight: null,
//       barcodeData: {
//         BoxNo: 1,
//         scannedData: enteredBarcodesList,
//         count: enteredBarcodesList.length,
//         OrderNum: selectedShipmentIDsString,
//         DistributorName: selectedDistributorNamesString,
//       },
//     };
//     console.log(shipmentDataToPost);

//     const postResult1 = Axios.post(
//       "http://13.200.156.92:5000/createshipment",
//       shipmentDataToPost
//     );
//     console.log(postResult1.data);
//     swal({
//       title: "Outbound completed",
//       text: "",
//       icon: "success",
//     }).then(() => {
//       setTimeout(() => {
//         window.location.reload();
//       }, 1000);
//     });
//   }

//   const getUniqueFilteredDistributors = () => {
//     const filteredDistributors = data
//       .filter((order) => order.dispatchthrough === "Shivalik Enterprises")
//       .map((order) => order.distributorName);

//     const uniqueFilteredDistributors = [...new Set(filteredDistributors)];
//     return uniqueFilteredDistributors;
//   };

//   return (
//     <div className="outbound">
//       <h3>Scan Outbound</h3>

//       <div style={{ marginBottom: "1rem" }}>
//         <label>Select Distributor: </label>
//         <select
//           className=""
//           value={selectedDistributor || ""}
//           onChange={(e) => setSelectedDistributor(e.target.value || null)}
//         >
//           <option value="">All</option>
//           {getUniqueFilteredDistributors().map((distributor) => (
//             <option key={distributor} value={distributor}>
//               {distributor}
//             </option>
//           ))}
//         </select>
//       </div>

//       <div className="mpcontainer">
//         <div className="mpcontent">
//           <Table className="outboundtable">
//             <thead>
//               <tr>
//                 <th>Order No</th>
//                 <th>Distributor Name</th>
//                 <th>PO Date</th>
//                 <th>Select</th>
//                 <th>Title</th>
//                 <th>Medium</th>
//                 <th>SKU</th>
//                 <th>Order Quantity</th>
//               </tr>
//             </thead>
//             <br />
//             <tbody>
//               {data.map((order, orderIndex) =>
//                 order.updatedQuantity.map((item, itemIndex) => {
//                   if (
//                     (!selectedDistributor ||
//                       order.distributorName === selectedDistributor) &&
//                     order.dispatchthrough === "Shivalik Enterprises"
//                   ) {
//                     return (
//                       <tr key={`${order.orderid}-${itemIndex}`}>
//                         {itemIndex === 0 && (
//                           <>
//                             <td rowSpan={order.updatedQuantity.length}>
//                               {order.shipmentid}
//                             </td>
//                             <td rowSpan={order.updatedQuantity.length}>
//                               {order.distributorName}
//                             </td>{" "}
//                             <td rowSpan={order.updatedQuantity.length}>
//                               {new Date(order.ApprovalDate).toLocaleDateString(
//                                 "en-US",
//                                 {
//                                   day: "numeric",
//                                   month: "long",
//                                   year: "numeric",
//                                 }
//                               )}
//                             </td>
//                           </>
//                         )}
//                         <td>
//                           <input
//                             type="checkbox"
//                             onChange={() =>
//                               handleCheckboxChange(orderIndex, itemIndex)
//                             }
//                             checked={selectedRows.some(
//                               (row) =>
//                                 row.orderIndex === orderIndex &&
//                                 row.itemIndex === itemIndex
//                             )}
//                           ></input>
//                         </td>
//                         <td>{item.title}</td>
//                         <td>{item.Medium}</td>
//                         <td>{item.sku}</td>
//                         <td>{item.approvedquantity}</td>
//                       </tr>
//                     );
//                   } else {
//                     return null;
//                   }
//                 })
//               )}
//             </tbody>
//           </Table>
//         </div>
//       </div>

//       <div className="selected-row-inputs">
//         {data.map((order, orderIndex) =>
//           order.updatedQuantity.map(
//             (item, itemIndex) =>
//               selectedRows.some(
//                 (row) =>
//                   row.orderIndex === orderIndex && row.itemIndex === itemIndex
//               ) && (
//                 <div
//                   style={{ marginTop: "2rem" }}
//                   key={`${orderIndex}-${itemIndex}`}
//                 >
//                   <p>Enter Barcode Manually:</p>
//                   <input
//                     type="text"
//                     ref={barcodeInputRef}
//                     value={barcode}
//                     onChange={(e) => setBarcode(e.target.value)}
//                     onKeyUp={(e) => {
//                       if (e.key === "Enter") {
//                         handleManualBarcodeAddition();
//                       }
//                     }}
//                     disabled={isInputDisabled}
//                   />
//                   <button
//                     style={{ marginLeft: "1rem", padding: "4px" }}
//                     onClick={handleManualBarcodeAddition}
//                     type="button"
//                     className="btn btn-primary"
//                   >
//                     Add Manually
//                   </button>
//                   <div>
//                     <h4 className="outboundcount">
//                       Entered Barcodes Count: {enteredBarcodesList.length}
//                     </h4>
//                     <h5>Entered Barcodes:</h5>
//                     <ul>
//                       {enteredBarcodesList.map((barcode, index) => (
//                         <li key={index}>{barcode}</li>
//                       ))}
//                     </ul>
//                   </div>
//                 </div>
//               )
//           )
//         )}
//       </div>

//       <button
//         style={{ marginLeft: "22rem", marginBottom: "8rem" }}
//         type="button"
//         class="btn btn-primary"
//         onClick={handleSubmit}
//       >
//         {" "}
//         Save scanned ID
//       </button>
//     </div>
//   );
// }

// export default Outbound;


import { useState, useEffect, useRef } from "react";
import "./Outbound.css";
import Table from "react-bootstrap/Table";
import Axios from "axios";
import Button from "react-bootstrap/Button";
import swal from "sweetalert";
import alertify from "alertifyjs";
import "alertifyjs/build/css/alertify.min.css";

function Outbound() {
  const [data2, setData2] = useState([]);
  const [data, setData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [barcode, setBarcode] = useState("");
  const [enteredBarcodesList, setEnteredBarcodesList] = useState([]);
  const [scannedBarcodes, setScannedBarcodes] = useState([]);
  const barcodeInputRef = useRef(null);
  const [selectedCheckboxCount, setSelectedCheckboxCount] = useState(0);
  const [selectedDistributor, setSelectedDistributor] = useState(null);
  const [isInputDisabled, setIsInputDisabled] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  useEffect(() => {
    Axios.get("https://nodei.ssccglpinnacle.com/getshipment").then((response) => {
      setData(response.data);
    });

    Axios.get("https://nodei.ssccglpinnacle.com/getship").then((response) => {
      const latest30Data = response.data.slice(0, 200);
      // Map over the latest30Data to access each object's barcodeData
      const allScannedData = latest30Data.map(item => item.barcodeData
        // Map over each barcodeData to extract scannedData
        .map(barcode => barcode.scannedData)
      ).flat(2); // Flatten the array twice: first to flatten the outer map's result, then to flatten the scannedData arrays into a single array
    // console.log(allScannedData);
      setData2(allScannedData); // Store the flattened array of all scannedData strings
    });
  }, []);

  const handleCheckboxChange = (orderIndex, itemIndex) => {
    const updatedSelectedRows = [...selectedRows];
    const foundIndex = updatedSelectedRows.findIndex(
      (row) => row.orderIndex === orderIndex && row.itemIndex === itemIndex
    );

    if (foundIndex === -1) {
      updatedSelectedRows.push({ orderIndex, itemIndex });
      setSelectedCheckboxCount(selectedCheckboxCount + 1);
    } else {
      updatedSelectedRows.splice(foundIndex, 1);
      setSelectedCheckboxCount(selectedCheckboxCount);
    }

    setSelectedRows(updatedSelectedRows);

    if (selectedCheckboxCount === 1) {
      window.location.reload();
    }
  };
  const handleBarcodeScanned = (scannedBarcode) => {
    const selectedRow = selectedRows.find((row) =>
      scannedBarcode.includes(
        data[row.orderIndex].updatedQuantity[row.itemIndex].sku
      )
    );

    const isBarcodeAlreadyEntered =
      enteredBarcodesList.includes(scannedBarcode);

    if (isBarcodeAlreadyEntered) {
      alertify.error("Barcode already exists in the list");
      setBarcode("");
      return;
    }

    const isBarcodeInDatabase = data2.includes(scannedBarcode);

    if (isBarcodeInDatabase) {
      alertify.error("Barcode already present in Database");
      setBarcode("");
      return;
    }

    if (selectedRow) {
        const selectedItem =
            data[selectedRow.orderIndex].updatedQuantity[selectedRow.itemIndex];

            setSelectedItem(selectedItem);
      const skuExists = selectedRows.some((row) =>
        scannedBarcode.includes(
          data[row.orderIndex].updatedQuantity[row.itemIndex].sku
        )
      );

      if (enteredBarcodesList.length === selectedItem.approvedquantity) {
        alertify.alert("Quantity matched", "Stop scanning.").set({
          onshow: function () {
            setIsInputDisabled(true);
          },
          onclose: function () {
            setIsInputDisabled(false);
          },
        });
        setBarcode("");
        return;
      }

      if (skuExists) {
        setScannedBarcodes([
          ...scannedBarcodes,
          {
            enteredBarcode: scannedBarcode,
          },
        ]);
        setBarcode("");
        setEnteredBarcodesList([...enteredBarcodesList, scannedBarcode]);

        if (enteredBarcodesList.length === selectedItem.approvedquantity - 1) {
          alertify.alert("Quantity matched", "Stop scanning.");
          setBarcode("");
          return;
        }

        alertify.success("Barcode scanned successfully");
      } else {
        alertify.error("SKU not found in the scanned barcode");
        setBarcode("");
      }
    } else {
      alertify.error("SKU not found in the scanned barcode");
      setBarcode("");
    }
  };

  const handleManualBarcodeAddition = () => {
    if (barcode.trim() !== "") {
      const skuExists = selectedRows.some((row) =>
        barcode.includes(
          data[row.orderIndex].updatedQuantity[row.itemIndex].sku
        )
      );

      if (skuExists) {
        handleBarcodeScanned(barcode);
      } else {
        alertify.error("SKU not found in the entered barcode");
        setBarcode("");
      }
    } else {
      alertify.error("Please enter a barcode");
      setBarcode("");
    }
  };

  useEffect(() => {
    if (barcodeInputRef.current) {
      barcodeInputRef.current.focus();
    }

    const handleClickOutsideInput = (event) => {
      if (
        barcodeInputRef.current &&
        !barcodeInputRef.current.contains(event.target)
      ) {
        barcodeInputRef.current.focus();
      }
    };

    document.addEventListener("click", handleClickOutsideInput);

    return () => {
      document.removeEventListener("click", handleClickOutsideInput);
    };
  }, []);

  function handleSubmit() {
    if (enteredBarcodesList.length === 0) {
      swal("Error", "Please add a barcode first", "error");
      return;
    }

       if (enteredBarcodesList.length < selectedItem.approvedquantity ) {
      alertify.error("Scanned Qty is less than Approved Qty");
      return;
    }

    const selectedShipmentIDsString = selectedRows
      .map((row) => data[row.orderIndex].shipmentid)
      .join(", ");

    const selectedDistributorNamesString = selectedRows
      .map((row) => data[row.orderIndex].distributorName)
      .join(", ");

    const orderNumbers = selectedRows
      .map((row) => data[row.orderIndex].orderid)
      .join(", ");
    const batchIDs = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].batchid)
      .join(", ");
    const titles = selectedRows
      .map((row) => data[row.orderIndex].updatedQuantity[row.itemIndex].title)
      .join(", ");

    const dataToSend = {
      orderno: orderNumbers,
      barcodeData: enteredBarcodesList,
      count: enteredBarcodesList.length,
      BatchID: batchIDs,
      Title: titles,
    };

    console.log(dataToSend);
    const postResult = Axios.post(
      "https://nodei.ssccglpinnacle.com/scanInbound",
      dataToSend
    );
    console.log(postResult.data);

    const shipmentDataToPost = {
      totalCount: enteredBarcodesList.length,
      totalBoxes: 1,
      totalWeight: null,
      barcodeData: {
        BoxNo: 1,
        scannedData: enteredBarcodesList,
        count: enteredBarcodesList.length,
        OrderNum: selectedShipmentIDsString,
        DistributorName: selectedDistributorNamesString,
      },
    };
    console.log(shipmentDataToPost);

    const postResult1 = Axios.post(
      "https://nodei.ssccglpinnacle.com/createshipment",
      shipmentDataToPost
    );
    console.log(postResult1.data);
    swal({
      title: "Outbound completed",
      text: "",
      icon: "success",
    }).then(() => {
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    });
  }

  const getUniqueFilteredDistributors = () => {
    const filteredDistributors = data
      .filter((order) => order.dispatchthrough === "Shivalik Enterprises")
      .map((order) => order.distributorName);

    const uniqueFilteredDistributors = [...new Set(filteredDistributors)];
    return uniqueFilteredDistributors;
  };

  return (
    <div className="outbound">
      <h3>Scan Outbound</h3>

      <div style={{ marginBottom: "1rem" }}>
        <label>Select Distributor: </label>
        <select
          className=""
          value={selectedDistributor || ""}
          onChange={(e) => setSelectedDistributor(e.target.value || null)}
        >
          <option value="">All</option>
          {getUniqueFilteredDistributors().map((distributor) => (
            <option key={distributor} value={distributor}>
              {distributor}
            </option>
          ))}
        </select>
      </div>

      <div className="mpcontainer">
        <div className="mpcontent">
          <Table className="outboundtable">
            <thead>
              <tr>
                <th>Order No</th>
                <th>Distributor Name</th>
                <th>PO Date</th>
                <th>Select</th>
                <th>Title</th>
                <th>Medium</th>
                <th>SKU</th>
                <th>Order Quantity</th>
              </tr>
            </thead>
            <br />
            <tbody>
              {data.map((order, orderIndex) =>
                order.updatedQuantity.map((item, itemIndex) => {
                  if (
                    (!selectedDistributor ||
                      order.distributorName === selectedDistributor) &&
                    order.dispatchthrough === "Shivalik Enterprises"
                  ) {
                    return (
                      <tr key={`${order.orderid}-${itemIndex}`}>
                        {itemIndex === 0 && (
                          <>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.shipmentid}
                            </td>
                            <td rowSpan={order.updatedQuantity.length}>
                              {order.distributorName}
                            </td>{" "}
                            <td rowSpan={order.updatedQuantity.length}>
                              {new Date(order.ApprovalDate).toLocaleDateString(
                                "en-US",
                                {
                                  day: "numeric",
                                  month: "long",
                                  year: "numeric",
                                }
                              )}
                            </td>
                          </>
                        )}
                        <td>
                          <input
                            type="checkbox"
                            onChange={() =>
                              handleCheckboxChange(orderIndex, itemIndex)
                            }
                            checked={selectedRows.some(
                              (row) =>
                                row.orderIndex === orderIndex &&
                                row.itemIndex === itemIndex
                            )}
                          ></input>
                        </td>
                        <td>{item.title}</td>
                        <td>{item.Medium}</td>
                        <td>{item.sku}</td>
                        <td>{item.approvedquantity}</td>
                      </tr>
                    );
                  } else {
                    return null;
                  }
                })
              )}
            </tbody>
          </Table>
        </div>
      </div>

      <div className="selected-row-inputs">
        {data.map((order, orderIndex) =>
          order.updatedQuantity.map(
            (item, itemIndex) =>
              selectedRows.some(
                (row) =>
                  row.orderIndex === orderIndex && row.itemIndex === itemIndex
              ) && (
                <div
                  style={{ marginTop: "2rem" }}
                  key={`${orderIndex}-${itemIndex}`}
                >
                  <p>Enter Barcode Manually:</p>
                  <input
                    type="text"
                    ref={barcodeInputRef}
                    value={barcode}
                    onChange={(e) => setBarcode(e.target.value)}
                    onKeyUp={(e) => {
                      if (e.key === "Enter") {
                        handleManualBarcodeAddition();
                      }
                    }}
                    disabled={isInputDisabled}
                  />
                  <button
                    style={{ marginLeft: "1rem", padding: "4px" }}
                    onClick={handleManualBarcodeAddition}
                    type="button"
                    className="btn btn-primary"
                  >
                    Add Manually
                  </button>
                  <div>
                    <h4 className="outboundcount">
                      Entered Barcodes Count: {enteredBarcodesList.length}
                    </h4>
                    <h5>Entered Barcodes:</h5>
                    <ul>
                      {enteredBarcodesList.map((barcode, index) => (
                        <li key={index}>{barcode}</li>
                      ))}
                    </ul>
                  </div>
                </div>
              )
          )
        )}
      </div>

      <button
        style={{ marginLeft: "22rem", marginBottom: "8rem" }}
        type="button"
        class="btn btn-primary"
        onClick={handleSubmit}
      >
        {" "}
        Save scanned ID
      </button>
    </div>
  );
}

export default Outbound;
